



















import { Prop } from "vue-property-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import { Component, Mixins } from "vue-mixin-decorator";
import ChatColorTypeSelect from "@/app/basic/common/components/select/ChatColorTypeSelect.vue";
import RangeComponent from "@/app/basic/common/components/RangeComponent.vue";

@Component({ components: { RangeComponent, ChatColorTypeSelect } })
export default class TrRangeComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private labelName!: string;

  @Prop({ type: Number, default: 3 })
  private rawWidth!: number;

  @Prop({ type: Number, default: 10 })
  private sliderWidth!: number;

  @Prop({ type: Number, default: null })
  private min!: number | null;

  @Prop({ type: Number, default: 1 })
  private step!: number;

  @Prop({ type: Number, default: null })
  private max!: number | null;

  @Prop({ type: Number, required: true })
  private value!: number;

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean;

  private input(value: number) {
    this.$emit("input", value);
  }

  public get localValue(): number {
    return this.value;
  }
  public set localValue(value: number) {
    this.input(value);
  }
}
